import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PartnerState, GetPartnersParams } from "@/types/admin/partner-type";
import { partnerService } from "@/services/system-admin/admin-data.service";

const initialState: PartnerState = {
  partners: [],
  loading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 20,
};

export const fetchPartners = createAsyncThunk(
  "partners/fetchPartners",
  async (params: GetPartnersParams) => {
    const response = await partnerService.getPartners(params);
    return { ...response, page: params.page, pageSize: params.pageSize };
  }
);

const partnerSlice = createSlice({
  name: "partners",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartners.fulfilled, (state, action) => {
        state.loading = false;
        const list = action.payload.result?.items || [];
        state.partners = list;
        state.currentPage = action.payload.page || 1;
        state.pageSize = action.payload.pageSize || 20;
        // ✅ totalRecordCount lives inside each item
        state.totalCount = list[0]?.totalRecordCount || 0;
      })
      .addCase(fetchPartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch partners";
      });
  },
});

export const { clearError } = partnerSlice.actions;
export default partnerSlice.reducer;